import logo from './logo.svg';
import './App.css';
import Hero from './components/hero';
import Header from './components/header';
import { Route, Routes } from "react-router-dom";
import Home from './components/home';
import Footer from './components/footer';
import Vulnerable from './components/vulnerable';
import ServiceMain from './components/servicemain';
import DataProtectionPolicy from './components/dataprotectionpolicy';
import CaseForm from './components/caseform';
import Contact from './components/contact';
import Terms from './components/terms';


function App() {
  return (
    <div className="App">
       <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServiceMain />} />
        <Route path="vulnerablepeople" element={<Vulnerable />} />
        <Route path="data-protection-policy" element={<DataProtectionPolicy />} />
        <Route path="terms-and-conditions" element={<Terms />} />
        <Route path="/case-form" element={<CaseForm />} />
        <Route path="/contactus" element={<Contact />} />
      </Routes>
      <Footer/>
    </div>
  );
}

export default App;
